<template>
    <div v-if="webInfo">
        <div class="schoolInfo">
            <el-image lazy class="schoolInfoBackground" :src="globalConfig.filePath + webInfo.WidgetSchool.part1.schoolInfoBackground" fit="cover"></el-image>
            <div class="schoolInfoTitle">{{webInfo.WidgetSchool.part1.schoolInfoTitle}}</div>
            <div class="schoolInfoDetails">
                <video class="schoolInfoVideo" :src="globalConfig.filePath + webInfo.WidgetSchool.part1.schoolInfoVideo" preload="auto" poster controls></video>
                <div class="schoolInfoContent">
                    <p v-for="(item, index) in webInfo.WidgetSchool.part1.schoolInfoContent" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="schoolInfoMajorList">
                <div class="schoolInfoMajorInfo" v-for="(item, index) in webInfo.WidgetSchool.part1.majorList" :key="index">
                    <el-image v-if="index%2 != 0" lazy style="width: 100%;display:block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                    <div class="schoolInfoMajorName">
                        <span>{{item.number}}</span>
                        <span>{{item.majorName}}</span>
                    </div>
                    <el-image v-if="index%2 == 0" lazy style="width: 100%;display:block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                </div>
            </div>
        </div>

        <div class="brandHistory">
            <el-image lazy class="brandHistoryBackground" :src="globalConfig.filePath + webInfo.WidgetSchool.part2.brandHistoryBackgroundSrc" fit="cover"></el-image>
            <div class="brandHistoryTitle">品牌历程</div>
            <div class="brandHistoryLine">
                <div>
                    <div style="height: 200px;">
                        <template v-for="(item, index) in webInfo.WidgetSchool.timeLineListTop">
                            <div class="brandHistoryLineTime" :id="'timeT' + index" style="display: flex;" :key="index">
                                <div class="brandHistoryLineTimeBTT"></div>
                                <div class="brandHistoryLineTimeText">
                                    <p>{{item.time}}</p>
                                    <p>{{item.content}}</p>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="brandHistoryLineTimeLineDiv">
                        <div v-for="itemL in 10" :key="itemL" class="brandHistoryLineTimeLine">
                            <div v-if="itemL == 1" id="timeLine0" style="width: 4px;height: 125px;background: #236de9;"></div>
                            <div v-for="itemS in 8" :key="itemS" style="width: 2px;height: 50px;background: #fff;"></div>
                            <div :id="'timeLine' + itemL" style="width: 4px;height: 125px;background: #236de9;"></div>
                        </div>
                        <div style="width: 4px;height: 125px;background: #236de9;"></div>
                    </div>
                    <div style="height: 200px;">
                        <template v-for="(item, index) in webInfo.WidgetSchool.timeLineListBottom">
                            <div class="brandHistoryLineTime" :id="'timeB' + index" style="display: flex;" :key="index">
                                <div class="brandHistoryLineTimeTTB"></div>
                                <div class="brandHistoryLineTimeText">
                                    <p>{{item.time}}</p>
                                    <p>{{item.content}}</p>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="elementTitle">八大优势</div>
        <div class="elementLabel">育大国工匠 创一流名校 铸百年事业</div>
        <div class="advantageListDiv">
            <div class="advantageList">
                <template v-for="(item, index) in webInfo.advantageList">
                    <div class="advantage" :key="index" v-if="index < 4">
                        <p class="advantageTitle" :advantageTitleIndex="index">{{item.title}}</p>
                        <p class="advantageLabel">{{item.label}}</p>
                        <div class="advantageButton">查看详情</div>
                        <el-image lazy class="advantagePic" style="height: 120px;width: 150px;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                    </div>
                </template>
            </div>
            <div class="advantageList">
                <template v-for="(item, index) in webInfo.advantageList">
                    <div class="advantage" :key="index" v-if="index > 3">
                        <p class="advantageTitle" :advantageTitleIndex="index">{{item.title}}</p>
                        <p class="advantageLabel">{{item.label}}</p>
                        <div class="advantageButton">查看详情</div>
                        <el-image lazy class="advantagePic" style="height: 120px;width: 150px;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
            that.$nextTick(() => {
                that.loadTimeLine();
            });
            window.addEventListener('resize', function () {
                if (that.$parent.activeTabs == 2) {
                    that.loadTimeLine();
                }
            });
        },
        methods: {
            loadTimeLine() {
                document.getElementById('timeT0').style.left =
                    document.getElementById('timeLine1').offsetLeft + 'px';
                document.getElementById('timeT1').style.left =
                    document.getElementById('timeLine3').offsetLeft + 'px';
                document.getElementById('timeT2').style.left =
                    document.getElementById('timeLine5').offsetLeft + 'px';
                document.getElementById('timeT3').style.left =
                    document.getElementById('timeLine7').offsetLeft + 'px';

                document.getElementById('timeB0').style.left =
                    document.getElementById('timeLine2').offsetLeft + 'px';
                document.getElementById('timeB1').style.left =
                    document.getElementById('timeLine4').offsetLeft + 'px';
                document.getElementById('timeB2').style.left =
                    document.getElementById('timeLine6').offsetLeft + 'px';
            },
        },
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .schoolInfo {
        width: 100%;
        height: auto;
        margin: 0 auto;
        position: relative;
        padding: 50px 0;
        box-sizing: border-box;
    }

    .schoolInfoBackground {
        height: 100%;
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0.1;
    }

    .schoolInfoTitle {
        font-size: 36px;
        font-weight: bold;
        line-height: 50px;
        width: 100%;
        text-align: center;
    }

    .schoolInfoDetails {
        display: flex;
        justify-content: space-between;
        width: 65%;
        margin: 0 auto;
        height: 330px;
        overflow: hidden;
        margin-top: 50px;
    }

    .schoolInfoVideo {
        height: 330px;
        width: auto;
        margin-right: 30px;
    }

    .schoolInfoContent {
        height: 330px;
        overflow: auto;
        font-size: 14px;
        line-height: 25px;
        min-width: 300px;
    }

    .schoolInfoContent p {
        margin-bottom: 10px;
    }

    .schoolInfoMajorList {
        display: flex;
        width: 65%;
        margin: 0 auto;
        height: 485px;
        overflow: hidden;
        margin-top: 50px;
    }

    .schoolInfoMajorInfo {
        width: calc(100% / 6);
    }

    .schoolInfoMajorName {
        width: 65%;
        margin: 0 auto;
        background-color: #ccc;
        font-size: 16px;
        height: 90px;
        align-items: baseline;
        padding-top: 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        font-weight: bold;
        overflow: hidden;
    }

    .schoolInfoMajorName span:nth-child(1) {
        font-size: 38px;
        color: #808080;
        text-align: center;
        font-weight: normal;
        margin-right: 5px;
    }

    .schoolInfoMajorInfo >>> img {
        transition: 0.3s;
    }

    .schoolInfoMajorInfo >>> img:hover {
        transform: scale(1.1);
    }

    .brandHistory {
        width: 100%;
        height: auto;
        margin: 0 auto;
        position: relative;
        padding: 30px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.8);
    }

    .brandHistoryBackground {
        height: 100%;
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0.3;
    }

    .brandHistoryTitle {
        font-size: 36px;
        font-weight: bold;
        line-height: 80px;
        width: 200px;
        margin: 0 auto;
        text-align: center;
        color: #236de9;
        border-bottom: 1px solid #236de9;
    }

    .brandHistoryLine {
        width: 100%;
        margin: 20px auto;
        padding: 20px;
        box-sizing: border-box;
    }

    .brandHistoryLineTimeBTT {
        width: 2px;
        height: 200px;
        background: linear-gradient(
            to top,
            rgba(255, 141, 26, 1) 0%,
            rgba(255, 141, 26, 0) 100%
        );
        position: relative;
    }

    .brandHistoryLineTimeBTT:before {
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #236de9;
        position: absolute;
        bottom: 0;
        left: -6px;
        z-index: 9999;
    }

    .brandHistoryLineTimeTTB {
        width: 2px;
        height: 200px;
        background: linear-gradient(
            to bottom,
            rgba(255, 141, 26, 1) 0%,
            rgba(255, 141, 26, 0) 100%
        );
        position: relative;
    }

    .brandHistoryLineTimeTTB:before {
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #236de9;
        position: absolute;
        top: 0;
        left: -6px;
        z-index: 9999;
    }

    .brandHistoryLineTimeLineDiv {
        display: flex;
        align-items: center;
        margin: 80px 0;
        justify-content: center;
        overflow: hidden;
    }

    .brandHistoryLineTimeLine {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .brandHistoryLineTimeText {
        width: calc(100vw / 6);
        min-width: 200px;
        height: 200px;
        overflow: hidden;
        color: #fff;
        padding: 5px 20px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 20px;
    }

    .brandHistoryLineTimeText p:nth-child(1) {
        font-size: 24px;
        line-height: 25px;
        margin-bottom: 10px;
    }

    .brandHistoryLineTime {
        position: absolute;
        left: 0;
        transition: 0.3s;
    }

    .advantageListDiv {
        width: 65%;
        margin: 10px auto;
    }

    .advantageList {
        display: flex;
    }

    .advantage {
        width: 25%;
        height: 250px;
        border: 1px solid #eee;
        padding: 10px 15px;
        box-sizing: border-box;
        position: relative;
    }

    .advantageTitle {
        width: 100%;
        font-size: 26px;
        color: #236de9;
        margin-bottom: 10px;
        font-weight: bold;
    }

    [advantageTitleIndex='1'],
    [advantageTitleIndex='3'],
    [advantageTitleIndex='5'],
    [advantageTitleIndex='7'] {
        color: #d43030 !important;
    }

    .advantageLabel {
        width: 100%;
        font-size: 12px;
        height: 68px;
        line-height: 17px;
        overflow: hidden;
    }

    .advantageButton {
        width: 90px;
        height: 25px;
        line-height: 25px;
        border: 1px solid #236de9;
        color: #236de9;
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
        background-color: #fff;
    }

    .advantagePic {
        position: absolute;
        bottom: 5px;
        right: 5px;
        z-index: -1;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetSchool.vue